module.exports = __webpack_public_path__ + "static/media/Family - Hexagon.306da6da.png";